import ThreeDModel from "@ui-kit/ThreeDModel/ThreeDModel";

const ThreeDFile = ({ file }) => {
  return <ThreeDModel modelSrc={file.src} />;
  // return <div>ThreeDFile</div>;
};

export default ThreeDFile;
